module.exports = __webpack_public_path__ + "media/assets/images/invalid_registration_address-d7a3b01149b43341c53f19b943952b5d.svg";